export default "__VITE_ASSET__njjSmEhd__"